/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import style from "../pipeline.module.scss";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Autocomplete, Pagination, TextField } from "@mui/material";
import greengif from "../../../../assets/images/imgpsh_fullsize_anim (1).gif";
import { FaFilter, FaPlus } from "react-icons/fa";
import accordionstyle from "../../../Candidate/CandidateQualifyForm/QualifyForm.module.scss";
import { baseurl_node } from "../../../../App";
import { io } from "socket.io-client";
import {
  GetCanLeadPipeline,
  GetCandidatePipeline,
  GetCandidateQualifyDetials,
  GetNotAttendEvent,
  PutCandidateType,
  PutMetaLeadAssignToAdmin,
  UpdateCanPipelineStatus,
  getCandidateLead,
  getcandidateDetails,
  GetAssignFb,
  GetAdminDetailsByID,
  GetAllAdminDetails,
  putCanLeadData,
} from "../../../../apiServices";
import {
  MyModal,
  addDaysToDate,
  dateFormate,
  dateAndTimeFormate,
  dateAndTimeHHMMSS,
  getCurrentDateTime,
  addHoursAndMinutesToDate,
  decryptedAdminID,
} from "../../../../utility";
import ModalContainer from "../../../../components/modal_popup";
import {
  CadidateDatailsendActions,
  CandidatePipelineActions,
  commonPopupActions,
  setShowMetaImageAction,
} from "../../../../redux-store/store";
import { useDispatch } from "react-redux";
import LeadPipelineFilter from "./LeadPipelineFilter";
import { useSelector } from "react-redux";
import QualifyFresherform from "../../../Candidate/CandidateQualifyForm/FresherForm";
import { AiOutlineClose } from "react-icons/ai";
import ExperienceForm from "../../../Candidate/CandidateQualifyForm/ExperienceForm";
import SuccessTick from "../../../../components/success_tick";
import { IoMdClose } from "react-icons/io";
import { LoadingButton } from "@mui/lab";
import { TfiImport } from "react-icons/tfi";
import Downloadicon from "../../../../assets/images/importicon1.jpg";
import { HiOutlineRefresh } from "react-icons/hi";
import CandidateLead from "../../../Candidate/CandidateLeadTable/CandidateLeadPostForm";
import { MdOutlineContentCopy } from "react-icons/md";
import MobileNumberfilter from "../../overallCountDetails/MobileNumberfilter";

function LeadGenerationPipeline({onSelectCandidate}) {
  const [leadData, setLeadData] = useState({
    data: [],
  });
  const Dispatch = useDispatch();

  let initialFilterObj = {
    mobileNumber: -1,
    assignTo: decryptedAdminID(),
    profilePageNo: -1,
    fromSource: "",
    jobCategory: "",
    currentStatus: "",
    dateFilterType: "",
    expYearsMax: -1,
    expYearsMin: -1,
    page: "",
    stages: 1,
    currentPipeline: "New candidate lead",
    pipelineStage: "New leads",
    startDate: "2020-01-01",
    endDate: dateFormate(new Date()),
    myTeam: true,
    isRegistered:false,
  };
  let filterDetails = useSelector(
    (state) => state.CandidatePipelineDetails.leadGenerationFilter
  );
  let filterDetailscandidate = useSelector(
    (state) => state.CandidatePipelineDetails.candidateFilter
  );
  let refreshPage = useSelector(
    (state) => state.CandidatePipelineDetails.refreshCountIncrement
  );
  let CandidateDetailsID = useSelector(
    (state) => state.CandidateSendDatails.CandidateDetailsSend.CandidateID
  );
  let CandidateDetailsopen = useSelector(
    (state) => state.CandidateSendDatails.CandidateDetailsSend.ShowCanWATemplate
  );
  let showImageMeta = useSelector(
    (state) => state.notificationmetaimage.showMetaImage
  );
  useEffect(() => {
    console.log(showImageMeta, "showImageMeta");
  }, [showImageMeta]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     Dispatch(setShowMetaImageAction.setShowMetaImage(false));
  //   }, 1000);

  //   // Cleanup the timeout on component unmount
  //   return () => clearTimeout(timer);
  // }, []);
  const adminDetails = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetails.roleID == 1;
  const [showFilter, setShowFilter] = useState(false);
  const [leadQualifyFormOpen, setLeadQualifyFormOpen] = useState(false);
  const [enableSubmit, setenableSubmit] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [leadDetails, setleadDetails] = useState("");
  const [showSuccessForm, setshowSuccessForm] = useState("");
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [fromFbMetaLeadAd, setFromFbMetaLeadAd] = useState(false);
  const [showCheckButton, setShowCheckButton] = useState(false);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [existingMobileNumber, setExistingMobileNumber] = useState("");
  // const [showmetaImage, setShowMetaImage] = useState(false);
  const [popups, setShowPopups] = useState({
    PopupAddCanLead: false,
    callRemainder: false,
    success: false,
    confirmation: false,
    notAttendConfiramtion: false,
    noresume: false,
    deleteConfirmation: false,
  });
  const [showLoader, setShowLoader] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [date, setDate] = React.useState(new Date());
  const [callRemainder, setCallRemainder] = useState({
    notes: "",
    date: null,
  });
  const [notAttendEventArray, setNotAttendEventArray] = useState([]);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [notAttendEvent, setNotAttendEvent] = useState("");
  const [eventError, setEventError] = useState("");
  const [showRedDot, setShowRedDot] = useState(false);
  const [dateTimeError, setDateTimeError] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [isAvailable, setisAvailable] = useState("");
  const [openWhatsappTem, setopenWhatsappTem] = useState("");
  const [hover, setHover] = useState(false);
  const [adminName, setAdminName] = useState({
    adminName: "",
    adminMobileNumer: "",
  });
  let adminID = decryptedAdminID();
  const currentDate = new Date();
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(0);
  // console.log(adminID, "adminID", filterDetails);

  const maxDate = new Date(currentDate.getTime() + 7 * 24 * 60 * 60 * 1000);

  async function fetchData() {
    setIsRotating(true);
    if (adminID != null) {
      let data = await GetCanLeadPipeline(filterDetails);

      if (data.status) {
        if (isSuperAdmin) {
          // Show all data if the user is a SuperAdmin
          setLeadData(data);
        } else {
          // Show only the first element if the user is not a SuperAdmin
          // let firstData = data.data.shift();
          // setLeadData((prev) => ({ ...prev, data: [firstData] }));
          setLeadData(data);
        }
        setTotalCount(data.totalElements);
      } else {
        setLeadData({
          data: [],
        });
        setTotalCount(0);
      }
    }
    setTimeout(() => {
      setIsRotating(false);
    }, 1000);
  }
  useEffect(() => {
    if (adminID != null) {
      GetAdminDetailsByID(adminID).then((data) => {
        //console.log(data.admin.emailId, "emailid");

        setisAvailable(data.admin.isAvailable);
      });

      fetchData();
      HandleOpenCandidate();
    }
  }, []);
  const handleCandidateDetails = async (candidateleadId, type) => {
    let data;
    if (type === "CandidateLead") {
      data = await getCandidateLead(candidateleadId);
    } else if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateleadId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateleadId,
        type: type,
        data: data,
      })
    );
  };

  let message = "";

  if (
    openWhatsappTem &&
    openWhatsappTem.firstName &&
    adminName &&
    adminName.adminName
  ) {
    message = `Vanakkam *${openWhatsappTem.firstName}* *${openWhatsappTem.lastName}*, 

*${openWhatsappTem.jobCategory}* velai thodarbana Thagavalgalukku *${adminName.adminMobileNumer}* ku call seiyavum.

*CNC Operator* fun videos ku, subscribe seiyavum:  
👉 *YouTube: * https://www.youtube.com/@toolroom-murugan  
👉 *Instagram: * https://www.instagram.com/machine_operators_meme?igsh=ODZxMmNtbHI1Y3Fs  

நன்றி,  
*Taizo.in HR Services*.
`;
  }

  const copyToClipboard = () => {
    if (!message) return;
    navigator.clipboard
      .writeText(message)
      .then(() => {
        setTooltipVisible(true);
        setTimeout(() => {
          setTooltipVisible(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Error copying text: ", err);
      });
  };

  const sendWhatsAppMessage = () => {
    if (!message || !openWhatsappTem.whatsappNumber) return;
    const url = `https://wa.me/${
      openWhatsappTem.whatsappNumber
    }?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };
  async function HandleOpenCandidate() {
    try {
      const candidateDetails = await getcandidateDetails(CandidateDetailsID);
      //console.log(candidateDetails, "after qualify");
      setopenWhatsappTem(candidateDetails);
      const assignto = decryptedAdminID(openWhatsappTem.assignTo);
      // console.log(assignto, "assignto");

      GetAdminDetailsByID(assignto).then((data) => {
        if (data && data.admin) {
          //console.log(data.admin, "data");
          setAdminName((prev) => ({
            ...prev,
            adminName: data.admin.userName,
            adminMobileNumer: data.admin.mobileNo,
          }));
        } else {
          console.error("Admin details not found.");
        }
      });
    } catch (error) {
      console.error("Error handling candidate:", error);
    }
  }

  function handleClose() {
    Dispatch(CadidateDatailsendActions.setOpenWATem(false));
  }

  useEffect(() => {
    if (adminID != null) {
      fetchData();
      setShowRedDot(ShowRedDot(initialFilterObj, filterDetails));

      GetAdminDetailsByID(adminID).then((data) => {
        //console.log(data.admin.emailId, "emailid");
        // setadminMobileNumber(data.admin.mobileNo);
        setAdminName((prev) => ({
          ...prev,
          adminName: data.admin.userName,
          adminMobileNumer: data.admin.mobileNo,
        }));

        setisAvailable(data.admin.isAvailable);
      });
      HandleOpenCandidate();
    }
  }, [filterDetails, refreshPage]);

  function ShowRedDot(obj1, obj2) {
    // Omitting the 'page' key from both objects
    const obj1WithoutPage = { ...obj1 };
    delete obj1WithoutPage.page;

    const obj2WithoutPage = { ...obj2 };
    delete obj2WithoutPage.page;
    for (let key in obj1WithoutPage) {
      if (obj1WithoutPage.hasOwnProperty(key)) {
        if (obj1WithoutPage[key] !== obj2WithoutPage[key]) {
          return true;
        }
      }
    }
    return false;
  }

  useEffect(() => {
    const fetchData = async () => {
      let data = await GetAssignFb();
      if (data.message === "Multiple leads found.") {
        setFromFbMetaLeadAd(true);
      } else {
        setFromFbMetaLeadAd(false);
      }
    };

    // Call fetchData immediately, then every 10 seconds
    fetchData();
    // const intervalId = setInterval(fetchData, 5000);

    // Clear interval on component unmount
    // return () => clearInterval(intervalId);
  }, []);

  function handleOpenQualifyForm() {
    setLeadQualifyFormOpen(true);
    GetCandidateQualifyDetials(leadDetails.mobileNumber)
      .then((data) => {
        if (data && data.canLeadDetails) {
          setSelectedOption(
            data.canLeadDetails?.experienced === true ? "experience" : "fresher"
          );
        } else {
          console.error("CanLeadDetails not available in data:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching candidate details:", error);
      });
  }
  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);

    let experiencedValue = false;
    if (selectedValue === "experience") {
      experiencedValue = true;
    }

    PutCandidateType(experiencedValue, leadDetails.mobileNumber, "").then(
      (data) => {}
    );
  };
  function handleCloseQualifyForm() {
    setSelectedOption("");
    setLeadQualifyFormOpen(false);
    fetchData();
  }
  async function candidateDetils() {
    try {
      const data = await GetCandidatePipeline(filterDetailscandidate);

      const firstCandidate = data.data.length > 0 ? data.data[0] : null;

      // //console.log(firstCandidate, "firstCandidate");

      if (firstCandidate) {
        // const { candidateleadId, type } = firstCandidate;
        handleCandidateDetails(firstCandidate.id, "RegisterCandidate");

        Dispatch(CandidatePipelineActions.setRefreshCount());
      } else {
        // //console.log("No candidates found in the data.");
      }
    } catch (error) {
      console.error("Error fetching candidate pipeline data:", error);
    }
  }
  function handleQualifyFormSubmit() {
    setshowSuccessForm(true);

    setTimeout(() => {
      setshowSuccessForm(false);
      setSelectedOption("");
      setLeadQualifyFormOpen(false);
    }, 1000);

    fetchData();
    setopenWhatsappTem(true);
    HandleOpenCandidate();
    // candidateDetils();
    // getMetaLead();
  }
  function handleQualifyFormSubmitupdate() {
    setshowSuccessForm(true);

    setTimeout(() => {
      setshowSuccessForm(false);
      setSelectedOption("");
      setLeadQualifyFormOpen(false);
    }, 1000);

    fetchData();
    //  candidateDetils();
    getMetaLead();
  }

  function paginationChange(event, page) {
    Dispatch(
      CandidatePipelineActions.setPageChange({
        type: "leadGenerationFilter",
        value: page - 1,
      })
    );
  }

  function handleCallRemainder(value) {
    setShowPopups((prev) => ({ ...prev, callRemainder: value }));
  }
  function handleCallNotAttend(value) {
    setShowPopups((prev) => ({ ...prev, notAttendConfiramtion: value }));
  }
  function handleNoResume(value) {
    setShowPopups((prev) => ({ ...prev, noresume: value }));
  }
  function showNotQualify(value) {
    setShowPopups((prev) => ({ ...prev, confirmation: value }));
  }
  function showDeleteConfirmation(value) {
    setShowPopups((prev) => ({ ...prev, deleteConfirmation: value }));
  }

  // function handleCallRemainderChange(name, value) {
  //   if (name === "date" && value instanceof Date) {
  //     // Extract the date value in the required format
  //     const formattedDate = dateFormate(value.toISOString()); // or any other format that suits your backend
  //     setCallRemainder((prev) => ({ ...prev, [name]: formattedDate }));
  //   } else {
  //     setCallRemainder((prev) => ({ ...prev, [name]: value }));
  //   }
  // }

  // function submitCallRemainder(e) {
  //   e.preventDefault();
  //   let obj = {
  //     callRemainder: dateFormate(callRemainder.date),
  //     notes: callRemainder.notes,
  //     id: leadDetails.id,
  //   };
  //   setShowLoader(true);
  //   UpdateCanPipelineStatus(obj).then((res) => {
  //     setShowLoader(false);
  //     handleCallRemainder(false);
  //     setCallRemainder({
  //       notes: "",
  //       date: "",
  //     });
  //     Dispatch(CandidatePipelineActions.setRefreshCount());
  //     getMetaLead();
  //   });
  // }

  function handleCallRemainderChange(name, value) {
    //console.log(value, "date formate");
    if (name === "date") {
      setDateTimeError(false);
      setCallRemainder((prev) => ({ ...prev, [name]: value }));
    } else {
      setCallRemainder((prev) => ({ ...prev, [name]: value }));
    }
  }

  function submitCallRemainder(e) {
    e.preventDefault();
    if (!callRemainder.date || !callRemainder.notes) {
      setDateTimeError(!callRemainder.date);
      return;
    }
    setenableSubmit(true);
    let obj = {
      callRemainder:
        callRemainder.date instanceof Date
          ? callRemainder.date.toISOString().split("T").join(" ")
          : callRemainder.date.split("T").join(" "),
      notes: callRemainder.notes,
      id: leadDetails.id,
    };
    setShowLoader(true);
    UpdateCanPipelineStatus(obj)
      .then((res) => {
        setShowLoader(false);
        handleCallRemainder(false);
        setenableSubmit(false);
        handleCallRemainderChange("date", ""); // Reset date after successful submission
        setCallRemainder({
          notes: "",
          date: "", // Reset date in state after submission
        });
        Dispatch(CandidatePipelineActions.setRefreshCount());
        // getMetaLead();
      })
      .catch((error) => {
        console.error("Error submitting call remainder:", error);
        setShowLoader(false);
        // Handle error state or message display
      });
  }
  const formattedDateTime = getCurrentDateTime();
  //

  function submitNotQualified(e) {
    e.preventDefault();
    if (!callRemainder.notes) {
      // setDateTimeError(!callRemainder.date);
      return;
    }
    setenableSubmit(true);
    let obj = {
      notQualified: true,
      notes: callRemainder.notes,
      date: formattedDateTime,
      id: leadDetails.id,
    };
    UpdateCanPipelineStatus(obj).then(() => {
      showNotQualify(false);
      setenableSubmit(false);
      setCallRemainder({
        notes: "",
      });
      Dispatch(CandidatePipelineActions.setRefreshCount());
      // getMetaLead();
    }, []);
  }
  function submitNotAttend() {
    if (notAttendEvent === "") {
      setEventError("Please select an event.");
      return;
    }
    setenableSubmit(true);
    let obj = {
      notAttend: true,
      event: notAttendEvent,
      date: formattedDateTime,
      id: leadDetails.id,
    };
    UpdateCanPipelineStatus(obj).then(() => {
      handleCallNotAttend(false);
      setenableSubmit(false);
      setNotAttendEvent("");
      Dispatch(CandidatePipelineActions.setRefreshCount());
      setIsNewPopupOpen(true);
      // getMetaLead();
    }, []);
  }

  function submitNoDocument() {
    setenableSubmit(true);
    let obj = {
      awaitCV: true,
      date: formattedDateTime,
      id: leadDetails.id,
    };
    UpdateCanPipelineStatus(obj).then(() => {
      handleNoResume(false);
      setenableSubmit(false);
      Dispatch(CandidatePipelineActions.setRefreshCount());
      // getMetaLead();
    }, []);
  }

  function deleteLead() {
    setenableSubmit(true);
    let obj = {
      id: leadDetails.id,
      notes: "Already registered",
    };
    setshowSuccessForm(true);
    putCanLeadData(obj).then(() => {
      showDeleteConfirmation(false);
      setenableSubmit(false);
      Dispatch(CandidatePipelineActions.setRefreshCount());
      // getMetaLead();
    }, []);
    setTimeout(() => {
      setshowSuccessForm(false);
    }, 1000);
  }

  function getMetaLead() {
    PutMetaLeadAssignToAdmin().then((res) => {
      Dispatch(CandidatePipelineActions.setRefreshCount());
    });
    Dispatch(setShowMetaImageAction.setShowMetaImage(false));
  }

  function ShowRedDot(obj1, obj2) {
    // Omitting the 'page' key from both objects
    const obj1WithoutPage = { ...obj1 };
    delete obj1WithoutPage.page;

    const obj2WithoutPage = { ...obj2 };
    delete obj2WithoutPage.page;
    for (let key in obj1WithoutPage) {
      if (obj1WithoutPage.hasOwnProperty(key)) {
        if (obj1WithoutPage[key] !== obj2WithoutPage[key]) {
          return true;
        }
      }
    }
    return false;
  }
  const handleCopyClick = () => {
    // Construct the message with proper formatting
    const message = `வணக்கம் *${leadDetails.name}* *${leadDetails.lastName}*,\n\nநாங்கள் உங்களை அழைக்க முயற்சித்தோம்.\n\nஉங்கள் profile-க்கு ஏற்ற வேலை வாய்ப்பு எங்களிடம் உள்ளது.\n\nTaizo.in HR Service-இல், 5000க்கும் மேற்பட்ட Machine Operators, Engineer-களுக்கு கட்டணமின்றி வேலை கிடைக்க உதவியுள்ளோம்.\n\nநான் *${adminName.adminName}*, வேலை தொடர்பான உதவிக்கு, *${adminName.adminMobileNumer}* என்ற எண்ணில் என்னை அழைக்கவும்.\n\nநன்றி\n*Taizo.in HR Services*\n--------------------------------------------------------------------------------\n\nHello *${leadDetails.name}* *${leadDetails.lastName}*,\n\nWe tried to call you.\n\nWe have a job opportunity that matches your profile.\n\nAt Taizo.in HR Service, we have helped more than 5000 Machine Operators, Engineers to get jobs free of charge.\n\nI am *${adminName.adminName}* please call me on *${adminName.adminMobileNumer}* for job related assistance.\n\Thanks\n*Taizo.in HR Services*`;

    // Copy the message to the clipboard
    navigator.clipboard
      .writeText(message)
      .then(() => {
        setTooltipVisible(true);
        setTimeout(() => setTooltipVisible(false), 2000); // Hide tooltip after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  useEffect(() => {
    GetNotAttendEvent().then((data) => {
      //
      setNotAttendEventArray(data);
    });
  }, []);

    const handleClick = (data) => {
    if (typeof onSelectCandidate === "function") {
      onSelectCandidate(data);
    } else {
      console.error("❌ onSelectCandidate missing at CandidateCard");
    }
  };
  return (
    <div className={`${style.pipelineContainer} mx-2`}>
      <div className={`${style.headerCard} p-2 d-flex justify-content-between`}>
        <div>
          <b>Lead ({totalCount}) </b>
        </div>
        <div className="mt-0">
          <div className="d-inline-block ">
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                getMetaLead();
                // setShowMetaImage(true);
              }}
            >
              {showImageMeta && (
                <img
                  src={Downloadicon}
                  alt="Download Icon"
                  style={{ width: "35px", height: "35px" }}
                />
              )}

              {/* <TfiImporticon /> */}
              {/* {fromFbMetaLeadAd && isAvailable === true && (
                <img
                  src={Downloadicon}
                  alt="Download Icon"
                  style={{ width: "35px", height: "35px" }}
                />
              )} */}
              {/* {showImageMeta ? (
                <img
                  src={Downloadicon}
                  alt="Download Icon"
                  style={{ width: "35px", height: "35px" }}
                />
              ) : null} */}
            </span>
          </div>{" "}
          <div className="d-inline-block mx-2">
            <span
              // style={{ cursor: "pointer", color: "#858585" }}
              onClick={() => {
                setShowPopups({
                  PopupAddCanLead: true,
                });
              }}
            >
              {" "}
              <FaPlus className={style.faplus} />
            </span>
          </div>{" "}
          <div className="d-inline-block">
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                fetchData();
              }}
            >
              {" "}
              <HiOutlineRefresh
                className={`${
                  isRotating ? style.refreshRotate : style.refreshcolor
                }`}
              />
            </span>
          </div>{" "}
          <div
            onClick={() => {
              setShowFilter(true);
            }}
            className="d-inline-block mx-1 "
            style={{ cursor: "pointer", color: "#858585" }}
          >
            <FaFilter />
            <p
              style={{
                backgroundColor: showRedDot ? "red" : "transparent",
                width: "9px",
                height: "9px",
                marginTop: "-12px",
                zIndex: 1000,
                marginLeft: "10px",
                borderRadius: "50%",
              }}
            ></p>{" "}
          </div>
        </div>
      </div>

      <div className={`${style.bodyContainer}`}>
        {leadData.data.map((el) => (
          <div
            key={el.id}
            onClick={() => {
              setleadDetails(el);
            }}
          >
            <div className={`${style.bodyCard}  `}>
              <div className={`${style.textContent} p-1 `}>
                <div className="d-flex justify-content-between">
                  {" "}
                  <div>
                    <span
                      onClick={() => {
                        handleCandidateDetails(el.id, "CandidateLead");
                      }}
                      // onClick={() => {
                      //   handleClick(el);
                      // }}
                      style={{ cursor: "pointer" }}
                      className={style.candidateName}
                    >
                      <b>
                        {el.name && el.name.trim() !== "" ? el.name : "No name"}{" "}
                        {el.lastName ? el.lastName : " "}
                      </b>
                    </span>
                  </div>{" "}
                  <div>
                    <>
                      {dateFormate(el.lastEnquiryAt) ===
                      dateFormate(new Date()) ? (
                        <div className="d-flex align-items-center justify-content-center">
                          <img
                            src={greengif}
                            alt=""
                            className=""
                            width={"40px"}
                            height={"25px"}
                            style={{ marginTop: "2.3px" }}
                          />
                        </div>
                      ) : (
                        <span>
                          {(() => {
                            const differenceDays = Math.floor(
                              (new Date().getTime() -
                                new Date(
                                  dateFormate(el.lastEnquiryAt)
                                ).getTime()) /
                                (1000 * 60 * 60 * 24)
                            );

                            const daysAgo = Math.abs(differenceDays);
                            if (daysAgo === 1) {
                              return (
                                <b style={{ fontSize: "12px" }}>Yesterday</b>
                              );
                            } else {
                              return (
                                <>
                                  {" "}
                                  <b style={{ fontSize: "12px" }}>
                                    {daysAgo} days ago
                                  </b>
                                </>
                              );
                            }
                          })()}
                        </span>
                      )}
                    </>
                  </div>
                </div>
                {el.jobCategory ? el.jobCategory : "-"}
                <br />
                <div className="d-flex justify-content-between">
                  <div>
                    {el.mobileNumber ? el.mobileNumber : "-"}{" "}
                    <span>
                      {el.registered === true ? (
                        <span className={style.candidateReg}>Registered</span>
                      ) : (
                        " "
                      )}
                    </span>
                  </div>
                  <b
                    style={{
                      border: "1px solid yellow",
                      backgroundColor: "lightyellow",
                      fontSize: "10px",
                      borderRadius: "8px",
                      marginRight: "18px",
                      padding: "4px",
                    }}
                  >
                    {el.fromSource === "Retention"
                      ? "Old lead"
                      : el.fromSource === null
                      ? "Meta lead"
                      : el.fromSource === "Sri Andal Nachiyar Polytechnic"
                      ? "SANP"
                      : el.fromSource}
                  </b>
                </div>
              </div>
           {el.leadDeactive === false&&   <div
                style={{ marginTop: "-20px" }}
                className="d-flex justify-content-end"
              >
                <div>
                  <div className="dropdown">
                    <span
                      style={{ cursor: "pointer" }}
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <BsThreeDotsVertical />
                    </span>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      {el.registered === false && (
                        <li
                          onClick={() => {
                            handleOpenQualifyForm();
                          }}
                        >
                          <a className="dropdown-item" href="#">
                            Qualified
                          </a>
                        </li>
                      )}
                      {el.registered === true && (
                        <li>
                          <a
                            onClick={() => {
                              showDeleteConfirmation(true);
                            }}
                            className="dropdown-item"
                            href="#"
                          >
                            Delete
                          </a>
                        </li>
                      )}
                      {el.registered === false && (
                        <li>
                          <a
                            onClick={() => {
                              showNotQualify(true);
                            }}
                            className="dropdown-item"
                            href="#"
                          >
                            Not Qualified
                          </a>
                        </li>
                      )}
                      <li>
                        <a
                          onClick={() => {
                            handleCallNotAttend(true);
                          }}
                          className="dropdown-item"
                          href="#"
                        >
                          Not Attend
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() => {
                            handleCallRemainder(true);
                          }}
                          className="dropdown-item"
                          href="#"
                        >
                          Call Remainder
                        </a>
                      </li>
                      {el.registered === false && (
                        <li>
                          <a
                            onClick={() => {
                              handleNoResume(true);
                            }}
                            className="dropdown-item"
                            href="#"
                          >
                            No Document
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 d-grid justify-content-center">
        <Pagination
          // variant="outlined"
          shape="rounded"
          color="success"
          boundaryCount={1}
          siblingCount={0}
          onChange={paginationChange}
          count={leadData.totalPages}
          size="small"
        />
      </div>

      {showFilter && (
        <MyModal>
          <ModalContainer
            // zIndex={2}
            childComponent={
              <>
                <LeadPipelineFilter
                  onclose={() => {
                    setShowFilter(false);
                  }}
                />
              </>
            }
          />
        </MyModal>
      )}

      {leadQualifyFormOpen && (
        <>
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div
                    className={`container d-flex align-itmes-center justify-content-between`}
                  >
                    <div className="">
                      <p>
                        <b>Candidate lead qualify form</b>
                      </p>
                      <div className="d-flex">
                        {" "}
                        <div className={`me-2  ${accordionstyle.radioInput}`}>
                          {/* <label className="form-check-label me-3"> */}
                          <input
                            type="radio"
                            name="fresher"
                            id="fresherYes"
                            value="fresher"
                            className={`form-check-input `}
                            checked={selectedOption === "fresher"}
                            onChange={handleOptionChange}
                          />
                          <label for="fresherYes">Fresher</label>
                          {/* </label> */}
                        </div>
                        <div className={`me-2  ${accordionstyle.radioInput}`}>
                          <label className="form-check-label">
                            <input
                              type="radio"
                              name="experience"
                              id="experienceNo"
                              value="experience"
                              className={`form-check-input `}
                              checked={selectedOption === "experience"}
                              onChange={handleOptionChange}
                            />
                            <label for="experienceNo">Experience</label>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="ms-5">
                      <div
                        className="btn btn-outline-danger"
                        onClick={handleCloseQualifyForm}
                      >
                        <AiOutlineClose />{" "}
                      </div>
                    </div>
                  </div>

                  <div>
                    <div>
                      {selectedOption === "fresher" ? (
                        <>
                          {/* <div className={`${accordionstyle.Container}`}> */}{" "}
                          <QualifyFresherform
                            mobilenumber={leadDetails.mobileNumber}
                            whatsappNumber={leadDetails.whatsappNumber}
                            Reloadpage={handleQualifyFormSubmit}
                          />
                          {/* </div> */}
                        </>
                      ) : selectedOption === "experience" ? (
                        // <ExperinenceWorkingform
                        //   mobilenumber={leadDetails.mobileNumber}
                        // />
                        <ExperienceForm
                          mobileNumber={leadDetails.mobileNumber}
                          whatsappNumber={leadDetails.whatsappNumber}
                          Reloadpage={handleQualifyFormSubmit}
                        />
                      ) : null}
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
      {showSuccessForm && (
        <MyModal>
          <ModalContainer
            zIndex="20006"
            childComponent={<SuccessTick HeadText="Successfully" />}
          />
        </MyModal>
      )}

      {popups.confirmation && (
        <>
          <MyModal>
            <ModalContainer
              zIndex="5000"
              childComponent={
                <>
                  <div>
                    <h5 className=""> Confirmation </h5>
                    <div>
                      Are you sure that you want to not qualify{" "}
                      <b>
                        {" "}
                        {leadDetails.name} {leadDetails.lastName}{" "}
                      </b>
                      ?
                    </div>
                    <form action="#" onSubmit={(e) => submitNotQualified(e)}>
                      <div>
                        {" "}
                        <TextField
                          label="Add Notes"
                          multiline
                          value={callRemainder.notes}
                          onChange={(e) => {
                            handleCallRemainderChange("notes", e.target.value);
                          }}
                          variant="outlined"
                          fullWidth
                          required
                          margin="normal"
                        />
                      </div>
                      <div className="d-flex justify-content-end flex-row mt-3 ">
                        <button
                          onClick={() => {
                            showNotQualify(false);
                          }}
                          className="btn btn-danger mx-3"
                        >
                          No
                        </button>{" "}
                        <button
                          className="btn btn-success"
                          type="submit"
                          disabled={enableSubmit}
                        >
                          Yes
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
      {popups.notAttendConfiramtion && (
        <>
          <MyModal>
            <ModalContainer
              // zIndex="5000"
              childComponent={
                <>
                  <div>
                    <h5 className=""> Confirmation </h5>
                    <div>
                      Are you sure that you want to not attend{" "}
                      <b>
                        {" "}
                        {leadDetails.name} {leadDetails.lastName}
                      </b>
                      , please select <b>event</b>?
                    </div>
                    <div>
                      <Autocomplete
                        id="tags-outlined"
                        className="mt-3"
                        options={notAttendEventArray.map((option) => option)}
                        fullWidth
                        getOptionLabel={(option) => option}
                        value={notAttendEvent}
                        onChange={(e, newValue) => {
                          setNotAttendEvent(newValue);
                          //console.log(newValue);
                          setEventError("");
                        }}
                        required
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Event"
                            placeholder="Event"
                          />
                        )}
                      />
                      {eventError && (
                        <div className="text-danger">{eventError}</div>
                      )}
                    </div>
                    <div className="d-flex justify-content-end flex-row mt-3 ">
                      <button
                        onClick={() => {
                          handleCallNotAttend(false);
                          setNotAttendEvent("");
                          setEventError("");
                        }}
                        className="btn btn-danger mx-3"
                      >
                        No
                      </button>{" "}
                      <button
                        onClick={submitNotAttend}
                        className="btn btn-success"
                        disabled={enableSubmit}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}

      {popups.callRemainder && (
        <>
          <MyModal>
            <ModalContainer
              childComponent={
                <>
                  <div style={{ width: "300px" }}>
                    {" "}
                    <div className="d-flex justify-content-between mb-3">
                      <h4 className="text-center">Call Remainder</h4>
                      <span
                        onClick={() => {
                          handleCallRemainder(false);
                        }}
                        className="btn btn-outline-danger"
                      >
                        {" "}
                        <IoMdClose />
                      </span>
                    </div>
                    <form onSubmit={(e) => submitCallRemainder(e)}>
                      {/* <div>
                      {" "}
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          label="Select date and time"
                          value={callRemainder.date}
                          onChange={(newValue) => {
                            handleCallRemainderChange("date", newValue);
                          }}
                          renderInput={(props) => (
                            <TextField
                              {...props}
                              error={dateTimeError}
                              helperText={
                                dateTimeError
                                  ? "Please select a date and time"
                                  : ""
                              }
                            />
                          )}
                        />
                      </LocalizationProvider>
                    </div> */}
                      <label htmlFor="">Follow up date : </label>
                      <input
                        type="datetime-local"
                        id="date"
                        name="date"
                        min={currentDate.toISOString().slice(0, -8)}
                        max={maxDate.toISOString().slice(0, -8)}
                        className="form-control"
                        onChange={(e) => {
                          const inputDateTime = e.target.value;
                          const formattedDateTime = inputDateTime + ":00"; // Append ":00" for seconds
                          handleCallRemainderChange("date", formattedDateTime);
                        }}
                        required
                      />

                      <div>
                        {" "}
                        {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <ClockPicker
                          date={date}
                          onChange={(newDate) => setDate(newDate)}
                        />
                      </LocalizationProvider> */}
                      </div>

                      <div>
                        {" "}
                        <TextField
                          label="Add Notes"
                          multiline
                          value={callRemainder.notes}
                          onChange={(e) => {
                            handleCallRemainderChange("notes", e.target.value);
                          }}
                          variant="outlined"
                          fullWidth
                          required
                          margin="normal"
                        />
                      </div>
                      <LoadingButton
                        type="submit"
                        loading={showLoader}
                        variant="outlined"
                        disabled={enableSubmit}
                      >
                        <span>Submit</span>
                      </LoadingButton>
                    </form>
                  </div>

                  {/* <div className="d-flex flex-row justify-content-end mt-3  ">
                      <button
                        type="button"
                        className="btn btn-danger mx-2"
                        onClick={() => {
                          setShowPopups((prev) => ({
                            ...prev,
                            callRemainder: false,
                          }));
                        }}
                      >
                        Close
                      </button>
                      <button className="btn btn-success" type="submit">
                        Submit
                      </button>
                    </div> */}
                </>
              }
            />
          </MyModal>
        </>
      )}
      {popups.PopupAddCanLead && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div className="p-2" style={{ width: "800px" }}>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="fs-4">
                      <b>Candidate Lead Generation</b>
                    </div>
                    <div className="d-flex align-items-center">
                      {showCheckButton && (
                        <button
                          type="button"
                          className="btn btn-outline-primary me-2"
                          style={{
                            padding: "5px 15px",
                            fontSize: "14px",
                            borderRadius: "4px",
                            border: "1px solid #169c50",
                            backgroundColor: hover ? "#169c50" : "transparent",
                            color: hover ? "white" : "#169c50",
                            cursor: "pointer",
                          }}
                          onMouseEnter={() => setHover(true)}
                          onMouseLeave={() => setHover(false)}
                          onClick={() => {
                            // Get mobile number - you'll need to pass this from CandidateLead
                            // For now, we'll handle this later
                            console.log("Check here clicked");
                            setShowMobileFilter(true);
                          }}
                        >
                          Check here
                        </button>
                      )}
                      <div
                        className="btn btn-outline-danger"
                        onClick={() => {
                          setShowPopups({
                            PopupAddCanLead: false,
                          });
                        }}
                      >
                        <AiOutlineClose />
                      </div>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{ height: "65vh", overflow: "auto" }}
                  >
                    <CandidateLead
                      oncloseLead={() =>
                        setShowPopups((prev) => ({
                          ...prev,
                          PopupAddCanLead: false,
                        }))
                      }
                      Reloadresponse={fetchData}
                      onShowCheckButton={setShowCheckButton}
                      onNumberExists={setExistingMobileNumber}
                    />
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}

      {popups.noresume && (
        <>
          <MyModal>
            <ModalContainer
              // zIndex="5000"
              childComponent={
                <>
                  <div>
                    <h5 className=""> Confirmation </h5>
                    <div>
                      Are you still waiting to receive{" "}
                      <b>
                        {" "}
                        {leadDetails.name} {leadDetails.lastName}{" "}
                      </b>{" "}
                      resume?{" "}
                      {/* <b>
                        {" "}
                        {leadDetails.name} {leadDetails.lastName}
                      </b> */}
                    </div>

                    <div className="d-flex justify-content-end flex-row mt-3 ">
                      <button
                        onClick={() => {
                          handleNoResume(false);
                        }}
                        className="btn btn-danger mx-3"
                      >
                        No
                      </button>{" "}
                      <button
                        onClick={submitNoDocument}
                        className="btn btn-success"
                        disabled={enableSubmit}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
      {popups.deleteConfirmation && (
        <>
          <MyModal>
            <ModalContainer
              // zIndex="5000"
              childComponent={
                <>
                  <div>
                    <h5 className=""> Confirmation </h5>
                    <div>
                      Are you sure you delete this candidate{" "}
                      <b>
                        {" "}
                        {leadDetails.name} {leadDetails.lastName}{" "}
                      </b>{" "}
                      ?{" "}
                      {/* <b>
                        {" "}
                        {leadDetails.name} {leadDetails.lastName}
                      </b> */}
                    </div>

                    <div className="d-flex justify-content-end flex-row mt-3 ">
                      <button
                        onClick={() => {
                          showDeleteConfirmation(false);
                        }}
                        className="btn btn-danger mx-3"
                      >
                        No
                      </button>{" "}
                      <button
                        onClick={deleteLead}
                        className="btn btn-success"
                        disabled={enableSubmit}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}

      {isNewPopupOpen && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <div
                  style={{
                    position: "relative",
                    maxHeight: "80vh",
                    overflow: "auto",
                    height: "400px",
                    width: "800px",
                  }}
                >
                  <button
                    onClick={handleCopyClick}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "transparent",
                      border: "none",
                      padding: "0.5rem",
                      borderRadius: "0.25rem",
                      cursor: "pointer",
                    }}
                    title="Copy to clipboard"
                  >
                    <i
                      className="fas fa-copy"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                  </button>
                  {tooltipVisible && (
                    <div
                      style={{
                        position: "absolute",
                        top: "40px",
                        right: "10px",
                        backgroundColor: "#000",
                        color: "#FFFFFF",
                        padding: "0.5rem",
                        borderRadius: "0.25rem",
                        fontSize: "0.75rem",
                        whiteSpace: "nowrap",
                        zIndex: 10,
                      }}
                    >
                      Message copied!
                    </div>
                  )}
                  <div>
                    <p>
                      வணக்கம்{" "}
                      <b>
                        {leadDetails.name} {leadDetails.lastName}
                      </b>
                    </p>
                    <p>நாங்கள் உங்களை அழைக்க முயற்சித்தோம்.</p>
                    <p>
                      உங்கள் profile-ற்கு ஏற்ற வேலை வாய்ப்பு எங்களிடம் உள்ளது.
                    </p>
                    <p>
                      Taizo.in HR Service-இல், 5000க்கும் மேற்பட்ட Machine
                      Operators, Engineer-களுக்கு கட்டணமின்றி வேலை கிடைக்க
                      உதவியுள்ளோம்.
                    </p>
                    <p>
                      நான் <b>{adminName.adminName}</b>, வேலை தொடர்பான உதவிக்கு,{" "}
                      <b>{adminName.adminMobileNumer}</b> என்ற எண்ணில் என்னை
                      அழைக்கவும்.
                    </p>
                    <p>நன்றி</p>
                    <p>
                      <b>Taizo.in HR Services</b>
                    </p>
                  </div>
                  <hr></hr>
                  <div>
                    <p>
                      Hello{" "}
                      <b>
                        {leadDetails.name} {leadDetails.lastName}
                      </b>
                    </p>
                    <p>We tried to call you.</p>
                    <p>We have a job opportunity that matches your profile.</p>
                    <p>
                      At Taizo.in HR Service, we have helped more than 5000
                      Machine Operators, Engineers to get jobs free of charge.
                    </p>
                    <p>
                      I am <b>{adminName.adminName}</b>, please call me on{" "}
                      <b>{adminName.adminMobileNumer}</b> for job related
                      assistance.
                    </p>
                    <p>Thanks</p>
                    <p>
                      <b>Taizo.in HR Services</b>
                    </p>
                  </div>
                  <div className="d-flex justify-content-end mt-3">
                    <button
                      onClick={() => {
                        setIsNewPopupOpen(false); // Close the popup
                      }}
                      style={{
                        backgroundColor: "#dc3545", // btn-danger color
                        color: "white",
                        border: "none",
                        padding: "0.5rem 1rem",
                        margin: "0.5rem",
                        borderRadius: "0.25rem",
                      }}
                    >
                      Close
                    </button>
                    <button
                      onClick={() => {
                        let phoneNumber = leadDetails.mobileNumber;

                        // Ensure the phone number is in string format
                        if (typeof phoneNumber !== "string") {
                          phoneNumber = String(phoneNumber);
                        }

                        // Add +91 if not already present
                        if (!phoneNumber.startsWith("+91")) {
                          phoneNumber = `+91${phoneNumber.replace(/^\+/, "")}`;
                        }

                        // Encode the message properly with formatting
                        const message = `வணக்கம் *${leadDetails.name}* *${leadDetails.lastName}*,\n\nநாங்கள் உங்களை அழைக்க முயற்சித்தோம்.\n\nஉங்கள் profile-ற்கு ஏற்ற வேலை வாய்ப்பு எங்களிடம் உள்ளது.\n\nTaizo.in HR Service-இல், 5000க்கும் மேற்பட்ட Machine Operators, Engineer-களுக்கு கட்டணமின்றி வேலை கிடைக்க உதவியுள்ளோம்.\n\nநான் *${adminName.adminName}*, வேலை தொடர்பான உதவிக்கு, *${adminName.adminMobileNumer}* என்ற எண்ணில் என்னை அழைக்கவும்.\n\nநன்றி\n*Taizo.in HR Services*\n--------------------------------------------------------------------------------\n\nHello *${leadDetails.name}* *${leadDetails.lastName}*,\n\nWe tried to call you.\n\nWe have a job opportunity that matches your profile.\n\nAt Taizo.in HR Service, we have helped more than 5000 Machine Operators, Engineers to get jobs free of charge.\n\nI am *${adminName.adminName}* please call me on *${adminName.adminMobileNumer}* for job related assistance.\n\Thanks\n*Taizo.in HR Services*`;

                        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
                          message
                        )}`;

                        window.open(whatsappLink, "_blank");
                        // setIsNewPopupOpen(false); // Close the popup after initiating WhatsApp
                      }}
                      style={{
                        backgroundColor: "#28a745", // btn-success color
                        color: "white",
                        border: "none",
                        padding: "0.5rem 1rem",
                        margin: "0.5rem",
                        borderRadius: "0.25rem",
                      }}
                    >
                      Send WhatsApp
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
      {CandidateDetailsopen && (
        <MyModal>
          <ModalContainer
            zIndex={20005}
            childComponent={
              <>
                <div className=" text-dark p-2 rounded-3 mb-2">
                  <div className="d-flex justify-content-between mt-1 mb-2">
                    <div className="mt-2">
                      Vanakkam{" "}
                      <b>
                        {openWhatsappTem?.firstName} {openWhatsappTem?.lastName}
                      </b>
                      ,{" "}
                    </div>
                    <div className="" style={{ position: "relative" }}>
                      {tooltipVisible && (
                        <div
                          className="text-dark rounded p-1 me-3"
                          style={{
                            zIndex: 20006,
                            position: "absolute",
                            right: "-100%",
                            top: "-50%",
                          }}
                        >
                          Copied!
                        </div>
                      )}
                      <div
                        className="text-dark me-1 fs-5"
                        style={{ cursor: "pointer" }}
                        onClick={copyToClipboard}
                      >
                        <MdOutlineContentCopy />
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <p>
                      <b>
                        {openWhatsappTem ? (
                          <b>{openWhatsappTem.jobCategory} </b>
                        ) : (
                          "Loading..."
                        )}
                      </b>{" "}
                      வேலையை விரைவாகப் பெற்றுத்தர உங்களுக்கு உதவுவதில் நான்
                      மகிழ்ச்சியடைகிறேன்.{" "}
                    </p>
                    <p>
                      நான் <b>{adminName.adminName}</b>, வேலை தொடர்பான உதவிக்கு,{" "}
                      <b>{adminName.adminMobileNumer}</b> என்ற எண்ணில் என்னை
                      அழைக்கவும்.
                    </p>{" "}
                    <p>
                      நன்றி{" "}
                      <div>
                        <b className="mb-2">Taizo.in HR Services.</b>
                      </div>
                    </p>
                  </div> */}
                  <div>
                    {" "}
                    <div>
                      <p>
                        {" "}
                        <b>{openWhatsappTem?.jobCategory}</b> velai thodarbana
                        Thagavalgalukku <b>{adminName?.adminMobileNumer}</b> ku
                        call seiyavum.
                      </p>
                    </div>
                    <div>
                      <b>CNC Operator</b> fun videos ku, subscribe seiyavum:
                      <div className="mt-2">
                        👉 <b>YouTube:</b>{" "}
                        <a
                          href="https://www.youtube.com/@toolroom-murugan"
                          className="text-primary"
                        >
                          Toolroom-murugan
                        </a>
                      </div>
                      <div>
                        👉 <b>Instagram: </b>
                        <a
                          href="https://www.instagram.com/machine_operators_meme?igsh=ODZxMmNtbHI1Y3Fs"
                          className="text-primary"
                        >
                          Machine-operator
                        </a>
                      </div>
                    </div>
                    <div className="mt-3">நன்றி,</div>
                    <div>
                      <b>Taizo.in HR Services.</b>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end aligin-items-center ">
                  <div className="btn btn-danger me-3" onClick={handleClose}>
                    Cancel
                  </div>

                  <div
                    className="btn btn-success"
                    onClick={() => {
                      sendWhatsAppMessage();
                      // //console.log("clicked");
                    }}
                  >
                    Send WhatsApp
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}

      {showMobileFilter && (
        <MyModal>
          <ModalContainer
            childComponent={
              <MobileNumberfilter
                setopenmobilenumber={setShowMobileFilter}
                initialMobileNumber={existingMobileNumber}
              />
            }
          />
        </MyModal>
      )}
    </div>
  );
}

export default LeadGenerationPipeline;
